
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Orléans dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Orléans certifiée Google Partner, aide les entreprises orléanaises à accroître leur notoriété et à gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Orléans dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Orléans certifiée Google Partner, aide les entreprises orléanaises à accroître leur notoriété et à gagner de nouveaux clients.",
        },
      ],
    };
  },
};
